
import productDetailPage from './pdp.js';
import isScrolled from './is-scrolled.js';
import A11yDialog from 'a11y-dialog';

function init() {
    productDetailPage();
	isScrolled();
	// retailerModal();
}
init();

// Get height of site nav
const navEl = document.querySelector('.site-nav');
const withPadding = navEl.clientHeight + 16;
document.querySelector('html').style.setProperty('--nav-height', `${withPadding}px`);


const menuItems = document.querySelectorAll(".site-nav-menu-desktop .menu-item-has-children");

// add aria attributes to nav items
menuItems.forEach(function (el) {
    el.setAttribute('data-expanded', 'false');
    el.querySelector('button').setAttribute('aria-expanded', 'false');
    el.querySelector('.sub-menu').setAttribute('aria-hidden', 'true');
})

let expandedItem = null;

const expandSubMenu = (item) => {
    const subMenu = item.querySelector("ul");
    const button = item.querySelector("button");
    expandedItem = item;

    subMenu.setAttribute("aria-hidden", "false");
    button.setAttribute("aria-expanded", "true");
    item.dataset.expanded = "true";
};

const collapseSubMenu = (item) => {
	if (!item) {
		return;
	}
    const subMenu = item.querySelector("ul");
    const button = item.querySelector("button");
    expandedItem = null;

    subMenu.setAttribute("aria-hidden", "true");
    button.setAttribute("aria-expanded", "false");
    item.dataset.expanded = "false";
};

menuItems.forEach((item) => {
    const button = item.querySelector("button");

    button.addEventListener("click", (event) => {
        if (button.ariaExpanded === "false") {
            expandSubMenu(item);
        } else {
            collapseSubMenu(item);
        }
    });

    item.addEventListener("mouseenter", () => {
        expandSubMenu(item);
    });
    item.addEventListener("mouseleave", () => {
        collapseSubMenu(item);
    });
});

document.addEventListener("keydown", (event) => {
    if (event.key === "Tab") {
        if (!expandedItem) {
            return;
        }

        const subMenu = expandedItem.querySelector("ul");

        const focusedElement = expandedItem.querySelector(":focus");
        const firstFocusableElement = expandedItem.querySelector("a");
        const lastFocusableElement = subMenu.lastElementChild.querySelector("a");

        if (!event.shiftKey && focusedElement === lastFocusableElement) {
            collapseSubMenu(expandedItem);
            return;
        }

        if (event.shiftKey && focusedElement === firstFocusableElement) {
            collapseSubMenu(expandedItem);
            return;
        }
    }

    if (event.key == "Escape") {
        collapseSubMenu(expandedItem);
    }
});


const retailerListButtons = document.querySelectorAll(".retailer-list-nav button");
const retailerCards = document.querySelectorAll('.retailer-card');
retailerListButtons.forEach(function (button) {
    
    button.addEventListener("click", (event) => {
        let groupID = button.dataset.retailerGroupToggle;

        document.querySelector(".retailer-list-nav button.active").classList.remove('active');
        button.classList.add('active');

        retailerCards.forEach(function (card) {

            let cardID = card.dataset.retailerCardGroups;

            if (groupID == 'all') {
                card.style.display = '';
                return;
            }

            if(cardID.includes(groupID)) {
                card.style.display = '';
            } else {
                card.style.display = 'none';
            }

        });
    });

});

// 50 50 video modals
document.addEventListener("DOMContentLoaded", function () {

    document.querySelectorAll('.modal').forEach(function(modal) {
        const dialog = new A11yDialog(modal);
        
        const dialogTrigger = document.querySelector('[data-modal-open="'+dialog.id+'"]');
        dialogTrigger.addEventListener('click', function() {
            dialog.show();
        });

        const videoEmbed = modal.querySelector('.embed-container');

        dialog.on('show', function() {
            document.documentElement.style.overflowY = 'hidden';

            if(videoEmbed) {
                const html = videoEmbed.dataset.videoEmbed;
                videoEmbed.innerHTML = html;
            }
        });

        dialog.on('hide', function() {
            document.documentElement.style.overflowY = '';

            if(videoEmbed) {
                videoEmbed.innerHTML = '';
            }
        });
    });
});

const searchModalEl = document.querySelector('#search-modal');
if (searchModalEl) {
	let cpSearchModal = new A11yDialog(searchModalEl);
}

// site notice
document.querySelectorAll('.sitewide-notice').forEach(function(notice) {
    var hash = notice.getAttribute('data-sitewide-notice');

    var hidden = localStorage.getItem('cp_sitewide_notice_' + hash);
    if (!hidden) {
        notice.style.display = '';
    }

    var closeButton = notice.querySelector('.sitewide-notice-close');
    closeButton.addEventListener('click', function() {
        notice.style.display = 'none';
        localStorage.setItem('cp_sitewide_notice_' + hash, true);
    });
});